import React from "react";
import PropTypes from "prop-types";
import { ModalHeader as ReactstrapModalHeader } from "reactstrap";

/**
 * Encabezado único de los modales del sistema: icono del tema, título y
 * descripción breve. Estilos globales en scss/dhn/_modals.scss (.dhn-modal-heading).
 *
 * <ModalHeader
 *   toggle={toggle}
 *   iconClass="fa-sliders"
 *   description={isNew ? "Agregar parámetro médico" : "Modificar parámetro médico"}
 *   subtitle="Configure el tipo, alcance y frecuencia del parámetro."
 * />
 *
 * `description` es el título (se conserva el nombre por compatibilidad).
 */
const ModalHeader = ({ iconClass, description, subtitle, iconVariant, ...props }) => (
  <ReactstrapModalHeader tag="div" {...props}>
    <div className="dhn-modal-heading">
      <span
        className={`dhn-modal-heading__icon${iconVariant === "danger" ? " is-danger" : ""}`}
        aria-hidden="true"
      >
        <i className={`fa ${iconClass}`} />
      </span>
      <div>
        <h5>{description}</h5>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  </ReactstrapModalHeader>
);

ModalHeader.propTypes = {
  description: PropTypes.node.isRequired,
  iconClass: PropTypes.string.isRequired,
  iconVariant: PropTypes.oneOf(["default", "danger"]),
  subtitle: PropTypes.node,
};

ModalHeader.defaultProps = {
  iconVariant: "default",
  subtitle: undefined,
};

export default ModalHeader;
